import { createFileRoute } from "@tanstack/react-router";
import { withMemberGate } from "@/lib/with-member-gate";
import { HealingSanctuary } from "@/components/sanctuary/HealingSanctuary";

export const Route = createFileRoute("/sanctuary")({
  head: () => ({
    meta: [
      { title: "The Healing Sanctuary — Recovery Trauma™" },
      { name: "description", content: "Explore a candlelit healing world with a private page-turning journal, compassion mirror, intention garden and optional calming sounds, without leaving the Sanctuary." },
      { property: "og:title", content: "The Healing Sanctuary — Recovery Trauma™" },
      { property: "og:description", content: "A calm, interactive healing room for trauma recovery, decorated with the seasons." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: withMemberGate(HealingSanctuary, "The Healing Sanctuary"),
});
